/**
 * Hệ thống tài khoản
 * NVTUAN1 22.07.2022
 */
export default {
  BudgetActiveGovernmentMoney: '511', // Thu hoạt động do NSNN cấp
  EstimateRegularExpenxe: '00821', // Dự toán chi thường xuyên
  EstimateIrregularExpenxe: '00822', // Dự toán chi không thường xuyên
  BalanceSheetAccountsDefault: [
    '0061',
    '0062',
    '0081',
    '0082',
    '00811',
    '00812',
    '00813',
    '00821',
    '00822',
    '00823',
    '0091',
    '0092',
    '0093',
    '00911',
    '00912',
    '00921',
    '00922',
    '00931',
    '00932'
  ], // danh sách tài khoản ngoại bản là tài khoản con của 006,008,009
  ListAccountToShowColumnFundStructure: ['0081', '0082', '0091', '0092', '0093'], // Danh sách tài khoản sẽ hiển thị cột Cơ cấu vốn
  ListAccountToShowBeginningAmount: ['2412', '4411', '4412', '4418'], // Danh sách các tài khoản hiển thi lũy kế
  RegularFund: '008211', // kinh phí thường xuyên
  IrregularFund: '008221', // Kinh phí không thường xuyên
  BasicConstructFund: '00921', // kinh phí xây dựng cơ bản

  VietNameseCurrency: '1121', // Tiền Việt nam
  ForeignCurrency: '1122', // Tiền nguyên tệ
  ForeignCurrency2: '1112', // Tiền ngoại tệ

  CreditAccountMoney: '337',
  CreditAccountNotReceipt: ['3661', '3662', '3664'],
  StateBankAccount: '112',
  SaleInvoice: ['131', '531', '1111', '1121', '33311'], // Hóa đơn

  Account007: '007', // Ngoại tệ các loại
  Account632: '632',
  Account008: '008',
  Account009: '009',
  StockAccount: ['152', '153', '155', '156'], // Tài khoản Kho
  MaterialStockAccount: '152', // Nguyên liệu, vật liệu
  ToolsStockAccount: '153', // Công cụ dụng cụ
  ProductStockAccount: '155', // Sản phẩm
  MerchandiseStockAccount: '156', // Hàng hóa
  ForeignDebtLastYear: '0061',
  ForeignDebtThisYear: '0062',
  InvestmentestimateLastYear: '0091',
  InvestmentestimateThisYear: '0092',
  InvestmentestimateNextYear: '0093',
  EstimatedRecurrentExpensesLastYear: '00811',
  IrregularSpendingBudgetLastYear: '00812',
  EstimatedRecurrentExpensesThisYear: '00821',
  IrregularSpendingBudgetThisYear: '00822',
  InvestigateExpenseLastYear: '00813',
  InvestigateExpenseThisYear: '00823',
  opCustomerBalanceAccount: '131',
  opSupplierBalanceAccount: '331',
  opEmployeeBalanceAccount: '141',
  ShortTermFinancialAssets: '1211',
  OtherPayablesToTheState: '3338',
  ShortTermLoanRepayments: '33821',
  LongTermLoanRepayments: '33822',
  ReceiveDeposit: '348',
  DevaluationFixedAsset: '61113',
  DevaluationFixedAsset2: '61123',
  DepreciationFixedAsset: '6143',
  AidSource: '6121',
  WelfareFixedAsset: '43122',
  ManufacturingBusiness: '154',
  LongTermFinancialInvestment: '1212',
  ForeignCurrenciesOfAllKinds: '007',
  ShowCashDrawWithTypeName: [
    // những tài khoản auto hiện cột nghiệp vụ trong màn số dư
    '004',
    '006',
    '007',
    '008',
    '009',
    '012',
    '013',
    '014',
    '018',
    '241',
    '242',
    '337',
    '366',
    '511',
    '512',
    '514',
    '611',
    '612',
    '614',
  ],
  ConditionFixedAssetCreditAccount: ['3371', '3374', '3661', '3662', '3664', '511'],
  DebitFaDecrement: '214',
};
